export default function TabBtn({ children, active, onClick, testid }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`px-4 py-2 rounded-lg text-xs sm:text-sm font-bold uppercase tracking-wide transition-colors ${
        active ? "bg-[#E5B85C] text-[#0B0F17]" : "text-slate-300 hover:bg-slate-800"
      }`}
    >
      {children}
    </button>
  );
}
